import * as queryString from 'query-string';
import * as React from 'react';
import HistoryUtil from 'src/utils/HistoryUtil';
import LoginDTO from 'src/models/LoginDTO';
import Routes from 'src/consts/Routes';
import {
    Alert,
    Button,
    Checkbox,
    Col,
    Form,
    Input,
    Layout,
    Row,
    Typography,
    FormInstance,
    Card,
    Flex
} from 'antd';
import { BreadcrumbsItem } from '../shared/GlobalBreadcrumb';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { StateStoreModel } from 'src/redux/state/StateStoreModel';
import { UserSessionActions } from 'src/redux/actions/UserSessionActions';
import { withRouter } from 'react-router-dom';

const FormItem = Form.Item;
const Content = Layout.Content;

interface LoginState {
    model: LoginDTO;
}

interface LoginProps {
    userName: string | null;
    loading: boolean;
    error: any;
    loginAction: (dto: LoginDTO) => void;
}

class Login extends React.Component<LoginProps & RouteComponentProps<{}>, LoginState> {
    private readonly _formRef = React.createRef<FormInstance>();
    private _clickedSubmit: boolean;

    constructor(props: LoginProps & RouteComponentProps<{}>) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);

        //let deepLinkState = queryString.parse(props.location.search) as LoginState;
        //console.log(props.location.search);
        this.state = {
            model: LoginDTO.create(),
            //returnUrl : deepLinkState.returnUrl
        };
    }

    componentDidUpdate(prevProps: LoginProps, prevState: LoginState) {
        // TODO: refacotor, this is a messy way to check that the login was successful


        if (this.props.userName !== null &&
            this.props.error === null &&
            !this.props.loading &&
            this._clickedSubmit) {
                // Replace so that clicking back goes to the return url (or home) and not the login screen

                const searchParams = new URLSearchParams(window.location.search);
                const returnUrl = searchParams.get("returnUrl");
                if (returnUrl) {
                    const newUrl = new URL(returnUrl, window.location.origin);

                    // this prevents a redirect loop to the login page since every history modification triggers componentDidUpdate
                    // (historyUtil) - maximum update depth exceeded https://react.dev/errors/185?invariant=185
                    // alex: I think this will work so long as the Login page itself doesn't make any calls that require authorization
                    const alreadyAtLoginRoute = newUrl.pathname === Routes.LOGIN
                    if (alreadyAtLoginRoute) {
                        console.log(`login: going to ${Routes.DASHBOARD} since returnurl was the login page`);
                        HistoryUtil.replace(Routes.DASHBOARD);
                        return;
                    }
                    console.log("login: setting history location to", newUrl.pathname);
                    HistoryUtil.replace(newUrl.pathname);
                } else {
                    console.log(`login: setting url to ${Routes.DASHBOARD}, no return url`);
                    HistoryUtil.replace(Routes.DASHBOARD);
                }
        }
    }

    handleSubmit(event: React.MouseEvent<HTMLButtonElement>) {
        let model = this._formRef ? (this._formRef.current as any).getFieldsValue() : null;
        let checkBox = false;
        if (model.rememberMe === "on") {
            checkBox = true;
        }
        const newModel = {...model, rememberMe: checkBox};
        this.props.loginAction(newModel);
        this._clickedSubmit = true;
    }

    render() {
        let alert: JSX.Element | null = null;
        if (this.props.error !== null) {
            let message = 'An error occurred while trying to log you in.';
            if (this.props.error.message) {
                message = this.props.error.message;
            }
            alert = (
                <Alert
                    message="Error"
                    description={message}
                    type="error"
                    showIcon={true}
                    style={{marginBottom: '12px'}}
                />);
        }

        let labelCol = { xs: 24, sm: 6, md: 6, lg: 7, xl: 7, xxl: 7 };
        let wrapperCol = { xs: 24, sm: 17, md: 17, lg: 17, xl: 17, xxl: 17 };
        let wrapperColNoLabel = {};
        Object.keys(wrapperCol).forEach((val) => {
            wrapperColNoLabel[val] = { span: wrapperCol[val], offset: (wrapperCol[val] + labelCol[val] > 24 ? 0 : labelCol[val]) };
        });

        return (
            <Content id="login-container" className="content-background-login"
            
            >
                <BreadcrumbsItem name="login">
                    Login
                </BreadcrumbsItem>
                <Row
                    justify="center"
                    align="middle"
                    style={{height: "calc(100vh - 64px)"}}
                    
                >
                    <Col xs={22} sm={20} md={12} lg={6}>
                        <Card>
                            {alert}
                            <Form ref={this._formRef} layout="vertical" onFinish={this.handleSubmit}>
                                <FormItem vertical
                                    name="userName"
                                    label="Username"
                                    rules={[{ required: true, message: 'Username is required' }]}
                                >
                                    <Input placeholder="Username" />
                                </FormItem>
                                <FormItem vertical
                                    name="password"
                                    label="Password"
                                    rules={[{ required: true, message: 'Password is required' }]}
                                >
                                    <Input.Password placeholder="Password" />
                                </FormItem>
                                <FormItem
                                    name="devUserName"
                                    label="Or Pick"
                                    labelCol={labelCol}
                                    wrapperCol={wrapperCol}
                                    className="hidden"
                                >
                                    <Input />
                                </FormItem>
                                <Row justify="space-between">
                                    <Col>
                                        <FormItem name="rememberMe">
                                            <Checkbox>Remember Me</Checkbox>
                                        </FormItem>
                                    </Col>
                                    <Col style={{ textAlign: 'right' }}>
                                        <FormItem>
                                            <Link to={Routes.REQUEST_RESET_PASSWORD}>Forgot Password?</Link>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Flex justify='end'>
                                    <FormItem>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            size="large"
                                            disabled={this.props.loading}
                                        >
                                            {this.props.loading ? (
                                                <span>
                                                    <LoadingOutlined /> Logging in...
                                                </span>
                                            ) : (
                                                <span>Login</span>
                                            )}
                                        </Button>
                                    </FormItem>
                                </Flex>
                            </Form>
                        </Card>

                        <Flex justify='center' style={{ marginTop: '16px', textAlign: 'center' }}>
                            <Typography.Text>
                                Log in using the same credentials as your <Typography.Link href="https://myshivvers.com" target="_blank" rel="noopener noreferrer">MyShivvers.com</Typography.Link> account
                            </Typography.Text>
                        </Flex>
                    </Col>
                </Row>
            </Content>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        loginAction: (dto: LoginDTO) => dispatch(UserSessionActions.login(dto))
    };
}

function mapStateToProps(state: StateStoreModel) {
    let userName: string | null = null;
    if (state.UserSession.Value !== null) {
        userName = state.UserSession.Value.userName;
    }
    return {
        loading: state.UserSession.Loading,
        error: state.UserSession.Error,
        userName: userName
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
